import React from "react";
import { Modal } from "react-bootstrap";
import AiGuardRosterTab from "./AiGuardRosterTab";

// Wide, scrollable modal - the split-view detail pane was too narrow for this screen's
// filters/table/selection all at once ("difficult and not user friendly to select guards
// and to view all details in one look"), so the roster gets its own full-width overlay
// instead of living in a tab. Same react-bootstrap Modal pattern already used throughout
// this app (see BulkSalaryUpdateModal.jsx and friends).
const GuardRosterModal = ({ order, onClose }) => (
  <Modal show onHide={onClose} size="xl" scrollable dialogClassName="guard-roster-modal">
    <Modal.Header closeButton>
      <Modal.Title>AI Guard Roster</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <AiGuardRosterTab order={order} />
    </Modal.Body>
  </Modal>
);

export default GuardRosterModal;
